/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gamecompanies_Riot1Inputs */

const ja_gamecompanies_riot1 = /** @type {(inputs: Gamecompanies_Riot1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riot Games`)
};

const en_gamecompanies_riot1 = /** @type {(inputs: Gamecompanies_Riot1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riot Games`)
};

/**
* | output |
* | --- |
* | "Riot Games" |
*
* @param {Gamecompanies_Riot1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const gamecompanies_riot1 = /** @type {((inputs?: Gamecompanies_Riot1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gamecompanies_Riot1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_gamecompanies_riot1(inputs)
	return en_gamecompanies_riot1(inputs)
});
export { gamecompanies_riot1 as "gameCompanies_riot" }